/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState, useEffect } from 'react'

import Menu from '../../../components/Menu'

import { useForm } from "react-hook-form"

import { get, post } from '../../../services/http'
import { notify } from '../../../components/Toast'

import { ToastContainer } from 'react-toastify'
import { useNavigate } from 'react-router-dom'

export default function index() {
  document.title = 'ایجاد میز'

  const navigate = useNavigate()
  const [resturantSelect, setResturantSelect] = useState('')
  const [resturantSelectAlert, setResturantSelectAlert] = useState(false)
  const [resturants, setResturants] = useState([])

  const { register, handleSubmit } = useForm()

  const shopHandler = (e) => {
    setResturantSelect(e.target.value)
  }

  const token = localStorage.getItem('token')
  
  const onSubmit = (data, e) => {
    e.preventDefault()

    if (resturantSelect.length === 0) {
      setResturantSelectAlert(true)
    } else {
      setResturantSelectAlert(false)
      post(`/api/admin/table/create?token=${token}`, {
        name: data.name,
        branch: resturantSelect
      }).then(response => {
        if (response.status === 201) {
          notify('success', 'میز جدید ساخت شد')
          setTimeout(() => {
            navigate('/servers')
          }, 2000)
        }
      }).catch(error => {
        if (error.response.data.data.code === 11000) {
          return notify('error', 'میز مورد نظر موجود می باشد')
        }
        notify('error', 'خطا در ارسال اطلاعات')
      })
    }
  }

  useEffect(() => {
    get(`/api/admin/shops?token=${token}`)
      .then(response => {
        setResturants(response.data.data.docs)
      }).catch(error => {
        notify('error', 'دریافت اطلاعات با خطا مواجه شد')
      })
  }, [token])

  return (
    <main id='panel'>
      <ToastContainer rtl />
      <Menu page={'server'} badgeCountDashboard={0} badgeCountOrder={0} />
      <article className='panelBody'>
        <section className='panelContent'>
          <div className='title'>
            <div className='right'>
              <div className='text'>
                ایجاد میز
              </div>
            </div>

            <div className='left'>
            </div>
          </div>

          <form onSubmit={handleSubmit(onSubmit)} className='form'>
            <div className='title'>
              * برای ایجاد میز جدید لطفا تمامی فیلد های مشخص شده را پر کنید.
            </div>
            <div className='lineTitle'>
              <hr />
              اطلاعات میز‌
              <hr />
            </div>
            <div className='row'>
              <div className='column'>
                <label htmlFor='tableNumber'>شماره میز * :</label>
                <input id='tableNumber' {...register("name", { required: true, minLength: 3 })} type='string' />
                <small id='tableNumberAlert'>شماره میز باید وارد شود</small>
              </div>
              <div className='column'>
                <label htmlFor='resturantName'>انتخاب رستوران * :</label>
                <select id='resturantName' {...register("shop", { 
                  onChange: (e) => {shopHandler(e)},
                    required: true })}>
                    <option id='none'>انتخاب کنید</option>
                    {resturants ? resturants.map((item, index) => {
                      return <option key={index} value={item._id}>{item.name}</option>
                    }) : ''}
                </select>
                <small id='resturantNameAlert' style={resturantSelectAlert ? { display : 'flex' } : { display: 'none' }}>رستوران باید انتخاب شود</small>
              </div>
            </div>
            <button className='createButton' >ایجاد میز</button>
          </form>
          <div className='copyright'>
            © تمامی حقوق برای <a href='https://ibills.ir'>ibills</a> محفوظ است. طراحی و توسعه توسط <a href='https://ham-team.ir'>هم تیم</a>
          </div>
        </section>
      </article>
    </main>
  )
}
